export default "skymp5-front/4c9effcbaeeb2d8ca70ae680ac1e3b9a.wav";